import { initSDK, isHeadless } from '@axway/amplify-cli-utils';
import snooplogg from 'snooplogg';
import pkg from 'open';

export default {
	desc: 'Opens a web browser to the change your password page',
	async action({ console }) {
		const { highlight } = snooplogg.styles;
		const { sdk } = initSDK();
		const open = pkg;

		if (isHeadless()) {
			throw new Error('Changing your login credentials requires a web browser and is unsupported in headless environments');
		}

		const url = `${sdk.platformUrl}#/user/credentials`;
		console.log(`Opening web browser to ${highlight(url)}`);
		await open(url);
	}
};
